import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { OfflineWrapper } from 'components/OfflineWrapper/OfflineWrapper';
import { PendoWrapper } from 'features/pendo/PendoWrapper';
import { LayoutElementsContextProvider } from 'contexts/LayoutElementsContext/LayoutElementsContext';
import { OfflineContextProvider } from 'contexts/OfflineContext/OfflineContext';
import { ThemeProvider } from './contexts/ThemeContext/ThemeContext';
import { TranslationProvider } from './contexts/TranslationContext/TranslationContext';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import './i18n'; // Import the i18n configuration

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const BASE_NAME = process.env.PUBLIC_URL ?? '/';

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={BASE_NAME}>
        <ThemeProvider>
          <TranslationProvider>
            <PendoWrapper>
              <LayoutElementsContextProvider>
                <OfflineContextProvider>
                  <OfflineWrapper>
                    <App />
                  </OfflineWrapper>
                </OfflineContextProvider>
              </LayoutElementsContextProvider>
            </PendoWrapper>
          </TranslationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
